import { useLocation, Navigate } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { Card, Space, Typography } from "antd";

import { getUserById } from "../api/userAPI";
import { UserForm } from "../components/UserForm";

const { Title } = Typography;

const UpdateUser = () => {
  const location = useLocation();
  const userId = location.state?.userId;

  const { data: userData, isLoading } = useQuery({
    queryKey: ["user", userId],
    queryFn: () => getUserById(userId),
    enabled: !!userId,
  });

  if (!userId) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Update User Account
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          User Information
        </Title>

        {!isLoading && (
          <UserForm
            initialData={{
              ...userData,
              branchId: userData?.branch?.id || userData?.branchId,
              branchName: userData?.branch?.branchName,
            }}
            mode="update"
            userId={userId}
          />
        )}
      </Card>
    </Space>
  );
};

export default UpdateUser;
